import type { CSSProperties } from 'react';
import { Card, Typography } from 'antd';
import { useAuthStore } from '@store/authStore';

const { Text, Paragraph } = Typography;

const pageStyle: CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 24,
  backgroundColor: '#f8f9fa',
  backgroundImage: 'radial-gradient(circle, var(--grid-line, #dde3ec) 1px, transparent 1px)',
  backgroundSize: '18px 18px',
};

const cardStyle: CSSProperties = {
  width: '100%',
  maxWidth: 520,
  position: 'relative',
  borderRadius: 2,
  border: '1px solid var(--border-default, #cbd5e1)',
  boxShadow: 'none',
};

const cornerTickStyle: CSSProperties = {
  position: 'absolute',
  top: -1,
  left: -1,
  width: 42,
  height: 42,
  borderTop: '2px solid var(--accent-ink, #1e40af)',
  borderLeft: '2px solid var(--accent-ink, #1e40af)',
  pointerEvents: 'none',
};

const labelStyle: CSSProperties = {
  display: 'block',
  marginBottom: 18,
  fontFamily: 'var(--font-mono, "IBM Plex Mono", monospace)',
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 0,
  color: 'var(--accent-ink, #1e40af)',
  textTransform: 'uppercase',
};

export default function AccessDeniedPage() {
  const email = useAuthStore((state) => state.user?.email);
  const account = email || 'this account';

  return (
    <div style={pageStyle}>
      <Card style={cardStyle}>
        <div style={cornerTickStyle} />
        <Text style={labelStyle}>ACCESS NOT PROVISIONED</Text>
        <Paragraph style={{ marginBottom: 0, color: 'var(--text-secondary, #475569)' }}>
          Your account ({account}) is authenticated but not yet set up in BizOps. Ask an
          administrator to add you.
        </Paragraph>
      </Card>
    </div>
  );
}
